import StringifiedParameterFormatter from "./StringifiedParameterFormatter.js";
import ResultData from "../enums/ResultData.js";
import ResultFormatterBase from "./ResultFormatterBase.js";
import ResultDataNew from "../enums/ResultDataNew.js";
import IterableDataProcessor from "../entities/IterableDataProcessor.js";

class SerializedParameterFormatter extends ResultFormatterBase{
    constructor(
        dataParameter, mapExtractedTo, emptyValue, separator, singleValueParser, throwOnError, isOptional, newStructurePath
    ) {
        super();

        if (!(dataParameter instanceof Object)){
            throw new TypeError('dataParameter must be an object');
        }

        if (!dataParameter.hasOwnProperty('key')){
            throw new TypeError('dataParameter must have an "key" property');
        }

        if (!dataParameter.hasOwnProperty('stringifiedAs')){
            throw new TypeError('dataParameter must have an "stringifiedAs" property');
        }

        if (!(dataParameter instanceof Object)){
            throw new TypeError('dataParameter must be an object');
        }

        if (!(mapExtractedTo instanceof Object)){
            throw new TypeError('mapExtractedTo must be an object');
        }

        if (singleValueParser && !(singleValueParser instanceof Function)){
            throw new TypeError('singleValueParser must be an function or undefined to use default');
        }

        if (typeof(throwOnError) === 'undefined'){
            this.throwOnError = false;
        }
        else{
            this.throwOnError = !!throwOnError;
        }

        if (typeof(isOptional) === 'undefined'){
            this.isOptional = true;
        }
        else{
            this.isOptional = !!isOptional;
        }

        if (typeof(newStructurePath) === 'undefined') {
            this.newStructurePath = [];
        }
        else if (newStructurePath instanceof Array) {
            this.newStructurePath = newStructurePath;
        }
        else {
            throw new TypeError('newStructurePath must be string or undefined');
        }

        this.dataParameter = dataParameter;
        this.mapExtractedTo = mapExtractedTo;
        this.emptyValue = emptyValue|| ';;;';
        this.separator = separator || ';';
        this.singleValueParser = singleValueParser || parseFloat;
    }

    formatNewStructure(result) {
        const value = IterableDataProcessor.getObjectContent(result, this.newStructurePath.concat(this.dataParameter.key));
        if (typeof(value) !== 'string') {
            return this.onFormattingFailed(result, 'Source data property is not a string type');
        }

        if (value === this.emptyValue) {
            return this.onFormattingFailed(result, 'Source data property is empty');
        }
        
        try {
            let formatted = StringifiedParameterFormatter(
                value, this.separator, this.dataParameter.stringifiedAs, this.singleValueParser
            );

            if (formatted) {
                // try to map properties
                for (let mapFrom in this.mapExtractedTo) {
                    const mapTo = this.mapExtractedTo[mapFrom];
                    if (formatted.hasOwnProperty(mapFrom)) {
                        IterableDataProcessor.setObjectContent(result, this.newStructurePath.concat(mapTo), formatted[mapFrom]);
                    }
                }
            }
            else {
                return this.onFormattingFailed(result, 'Unable to deserialize parameter');
            }
        } catch (error) {
            return this.onFormattingFailed(result, `Unable to deserialize parameter - ${error.message}`);
        }

        return result;
    }

    format (result){
        const dataProperty = this.newStructurePath.length ? ResultDataNew.Data.key: ResultData.Data.key;

        if (!result || !result[dataProperty].hasOwnProperty(this.dataParameter.key)){
            return this.onFormattingFailed(result, 'Source data property not found in result');
        }

        if (this.newStructurePath.length > 0) {
            return this.formatNewStructure(result);
        }

        if (typeof(result[dataProperty][this.dataParameter.key]) !== 'string'){
            return this.onFormattingFailed(result, 'Source data property is not a string type');
        }

        if (result[dataProperty][this.dataParameter.key] === this.emptyValue){
            return this.onFormattingFailed(result, 'Source data property is empty');
        }
        
        try {
            let formatted = StringifiedParameterFormatter(
                result[dataProperty][this.dataParameter.key], this.separator, this.dataParameter.stringifiedAs, this.singleValueParser
            );

            if (formatted){
                // try to map properties
                for (let mapFrom in this.mapExtractedTo) {
                    const mapTo = this.mapExtractedTo[mapFrom];
                    if (formatted.hasOwnProperty(mapFrom)){
                        result[dataProperty][mapTo] = formatted[mapFrom];
                    }
                }
            }
            else{
                return this.onFormattingFailed(result, 'Unable to deserialize parameter');
            }
        } catch (error) {
            return this.onFormattingFailed(result, `Unable to deserialize parameter - ${error.message}`);
        }

        return result;
    }

    onFormattingFailed(result, reason){
        if (!this.isOptional && this.throwOnError){
            throw new Error(`Formatting of ${this.dataParameter.key} failed for result ${result[ResultData.Id.key]} - ${reason}`);
        }

        return result;
    }
}

export default SerializedParameterFormatter;